import React from 'react';
import './App.scss';
import Plyr, {PlyrOptions, PlyrSource} from "plyr-react"
import "plyr-react/plyr.css"

const videoSrc: PlyrSource = {
    type: "video",
    sources: [
        {
            src: "/assets/videos/CONOCE%20LA%20HISTORIA%20DE%20ESPERANZA.mp4",
        }
    ],
};

const videoOptions: PlyrOptions  = {
    autoplay: true,
    muted: true
};


function App() {
    let ref: any = { current: { plyr: Plyr } };
    setTimeout(() => {
        document.getElementsByTagName('video')[0].muted = true;
        ref.current.plyr.play();
    }, 1000);
  return (
    <div className="wrapper">
        <div className="content-wrapper">
            <div className="content grid gap-4 grid-cols-1 md:grid-cols-2">
                <div className="w-full flex flex-col items-center">
                    <img className="w-full mb-6" src="/assets/images/left_title_dirty.png" alt="N"/>
                    <div className="w-full flex justify-center px-2">
                        <Plyr ref={ref} source={videoSrc} options={videoOptions} />
                    </div>
                    <div className="flex justify-center w-full px-10">
                        <img className="w-full mt-6" src="/assets/images/left_footer_dirty.png" alt="F"/>
                    </div>
                </div>
                <div className="w-full px-8">
                    <a href="https://dona.nutriendo.org">
                        <img className="w-full" src="/assets/images/right_dirty.png" alt="asd"/>
                    </a>
                </div>
            </div>
        </div>
        <div className="privacy w-full flex justify-center items-center bg-gray-300">
            <a className="text-blue-500 font-semibold" href="/assets/pdfs/AVISO_PRIVACIDAD_FN.pdf?v=0.0.1" target="_blank">Aviso de privacidad</a>
        </div>
    </div>
  );
}

export default App;
